export default __webpack_public_path__ + "static/media/K_sound.1c949d55.mp3";